import { Grid, Typography } from "@mui/material";

import HeaderFooterBox from "./HeaderFooterBox";

const Footer = ({ pageNumber, totalPages }) => (
  <HeaderFooterBox>
    <Grid container alignItems="flex-end" justifyContent="space-between">
      <Grid item>
        <img
          src="/images/aclymate-full-logo.png"
          alt="aclymate logo"
          style={{ height: 40, position: "relative", left: "-5px" }}
        />
        <Typography variant="caption" display="block" color="textPrimary">
          This report was prepared by Aclymate
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body1" color="textPrimary">
          Page {pageNumber} of {totalPages}
        </Typography>
      </Grid>
    </Grid>
  </HeaderFooterBox>
);
export default Footer;
